const processingLogFilter = (log) => ({
  warning: log.filter((x) => x.Type === 0),
  error: log.filter((x) => x.Type === 2),
  majorError: log.filter((x) => x.Type === 3)
})

export default processingLogFilter
